import { portalColors } from './portalStyles';

interface Props {
  firstName: string;
  businessName: string;
  logoUrl: string | null;
  accentColor: string;
}

function formatToday(): string {
  return new Date().toLocaleDateString('en-CA', { weekday: 'long', month: 'long', day: 'numeric' });
}

export function PortalHeader({ firstName, businessName, logoUrl, accentColor }: Props) {
  return (
    <div style={{ marginBottom: 24 }}>
      {/* Business branding */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
        {logoUrl ? (
          <img src={logoUrl} alt="" style={{ width: 40, height: 40, borderRadius: 10, objectFit: 'cover' }} />
        ) : (
          <div style={{
            width: 40, height: 40, borderRadius: 10, background: accentColor,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 18, fontWeight: 600, color: '#fff',
          }}>{businessName.charAt(0)}</div>
        )}
        <span style={{
          fontSize: 13, fontWeight: 600, letterSpacing: '1px', textTransform: 'uppercase',
          color: portalColors.secondary,
        }}>{businessName}</span>
      </div>

      {/* Greeting */}
      <div style={{ fontSize: 28, fontWeight: 500, color: portalColors.primary }}>
        Hey {firstName}
      </div>
      <div style={{ fontSize: 15, color: portalColors.secondary, marginTop: 4 }}>
        {formatToday()}
      </div>
    </div>
  );
}
